module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Semibold--f20dfd7873706e4dc6a6523bef4b845e.f20dfd7873706e4dc6a6523bef4b845e.woff";